import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { BrandLogo } from "@/components/brand-logo";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <BrandLogo className="h-12 text-2xl" />
      <h1 className="font-heading text-primary mt-12 text-6xl font-bold">404</h1>
      <p className="text-muted mt-4 text-lg">{t("notFound.title")}</p>
      <Button asChild className="mt-8 px-6">
        <Link to="/home">{t("notFound.home")}</Link>
      </Button>
    </div>
  );
}
